import React, { useContext, createContext, ReactNode } from 'react';

// @ts-ignore
type AnalyticsState = Analytics | { track: (any) => Promise<unknown> };

interface AnalyticsContext {
  analytics: AnalyticsState;
}

const AnalyticsStateContext = createContext<AnalyticsContext | null>(null);

const AnalyticsProvider = ({
  children,
  apiDomain
}: {
  children: ReactNode;
  apiDomain: string;
}) => {
  const analytics = {
    track: (event, properties) => {
      navigator.sendBeacon(
        `${apiDomain}/binoculars`,
        JSON.stringify({ event, properties })
      );
    }
  };

  return (
    <AnalyticsStateContext.Provider value={{ analytics }}>
      {children}
    </AnalyticsStateContext.Provider>
  );
};

const useAnalyticsState = (): AnalyticsContext => {
  const context = useContext(AnalyticsStateContext);

  if (context === null) {
    throw new Error(
      'useAnalyticsState must be used within a AnalyticsProvider'
    );
  }

  return context;
};

export { AnalyticsProvider, useAnalyticsState };
